import { Cloudinary } from '../../../utility/cloudinary';

// Cloudinary url api:
// http://cloudinary.com/documentation/image_transformations#reference

export const getCloudinaryUrl = (
    url: string,
    transform: string,
    fallbackUrl?: string,
    fileExtenson?: string,
    retinaTransform?: string,
    altText?: string,
) => {
    if (!url) {
        return getFallbackImgUrl(fallbackUrl);
    }
    return getTransformedImageUrl(url, transform, fileExtenson, retinaTransform, altText);
};

export const getFallbackImgUrl = (fallbackUrl?: string) => {
    const missingImageUrl = '/Assets/Images/missing-image.png';
    const src = fallbackUrl || missingImageUrl;

    return src;
};

export const getTransformedImageUrl = (
    url: string,
    transform: string,
    fileExtenson?: string,
    retinaTransform?: string,
    altText?: string,
) => {
    const sanitizedUrl = Cloudinary.sanitize(url, fileExtenson); // //res.cloudinary.com/coopsverige/image/upload/v1442921161/52045.jpg
    let imagePath = Cloudinary.imagePath(sanitizedUrl); // //res.cloudinary.com/coopsverige/image/upload/
    let imageIdentifier = Cloudinary.imageIdentifier(sanitizedUrl); // /v1442921161/52045.jpg

    if (!imageIdentifier) {
        return sanitizedUrl;
    }

    // Make more SEO friendly
    if (altText) {
        if (imagePath) {
            imagePath = Cloudinary.makeImagePathSeoFriendly(imagePath);
        }

        imageIdentifier = Cloudinary.makeImageIdentifierSeoFriendly(imageIdentifier, altText);
    }

    const transformedUrl = retinaTransform
        ? `${imagePath}${retinaTransform}/${removeStartingSlash(imageIdentifier)} 2x`
        : `${imagePath}${transform}/${removeStartingSlash(imageIdentifier)}`;

    return transformedUrl;
};

const removeStartingSlash = (str: string) => {
    if (!str) {
        return str;
    }

    if (str[0] === '/') {
        return str.slice(1);
    }

    return str;
};
